// extracted by css-extract-rspack-plugin
export default {"clickme-banners-tabs":"BannerTabs-module__clickme-banners-tabs--O5s7W","clickmeBannersTabs":"BannerTabs-module__clickme-banners-tabs--O5s7W"};